// src/services/studentFormService.js
import { api } from './api';

const API_URL = '/api/student-forms/';

export const studentFormService = {
    // Get all forms (HR only)
    getAllForms: async (params = {}) => {
        try {
            const response = await api.get(API_URL, params);
            return response;
        } catch (error) {
            console.error('Get all forms error:', error);
            throw error;
        }
    },

    // Get employee's own form
    getMyForm: async (employeeId) => {
        try {
            const response = await api.get(`${API_URL}my-form/?employee_id=${employeeId}`);
            return response;
        } catch (error) {
            console.error('Get my form error:', error);
            throw error;
        }
    },

    // Get employee's own form with params (pagination, search, filters)
    getMyFormWithParams: async (employeeId, params = {}) => {
        try {
            // Always include employee_id in the query params
            const queryParams = {
                employee_id: employeeId,
                ...params
            };

            // Remove any undefined values
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key] === undefined || queryParams[key] === null) {
                    delete queryParams[key];
                }
            });

            const response = await api.get(`${API_URL}my-form/`, {
                params: queryParams
            });
            return response;
        } catch (error) {
            console.error('Get my form with params error:', error);
            throw error;
        }
    },

    // Create new form (Employee)
    createForm: async (data) => {
        try {
            const response = await api.post(API_URL, data);
            return response;
        } catch (error) {
            console.error('Create form error:', error);
            throw error;
        }
    },

    // Update form (Employee)
    updateForm: async (id, data) => {
        try {
            const response = await api.patch(`${API_URL}${id}/`, data);
            return response;
        } catch (error) {
            console.error('Update form error:', error);
            throw error;
        }
    },

    // HR Update (HR only)
    hrUpdate: async (id, data) => {
        try {
            const response = await api.patch(`${API_URL}${id}/hr-update/`, data);
            return response;
        } catch (error) {
            console.error('HR update error:', error);
            throw error;
        }
    },

    // Delete form (Admin only)
    deleteForm: async (id) => {
        try {
            const response = await api.delete(`${API_URL}${id}/`);
            return response;
        } catch (error) {
            console.error('Delete form error:', error);
            throw error;
        }
    },

    // Get form by ID
    getFormById: async (id) => {
        try {
            const response = await api.get(`${API_URL}${id}/`);
            return response;
        } catch (error) {
            console.error('Get form by ID error:', error);
            throw error;
        }
    }
};